mutation deleteCaseNote($id: ID!) {
  deleteCaseNote(input: { id: $id }) {
    success
  }
}
